import { getConfig } from '@atlassian/teams-common/context-config';

// Needs to be declared here to avoid blowing up this earlyInit bundle
class FetchError extends Error {
  constructor(response) {
    super(`Request failed with status ${response.status}`);
    this.response = response;
    this.name = this.constructor.name;
  }
}
// export for testing
export class UserInfoProvider {
  get(fetchOp = fetch) {
    if (this.promise) {
      return this.promise;
    }
    const getJson = url => fetchOp(url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      if (!response.ok) {
        throw new FetchError(response);
      }
      return response.json();
    });
    this.promise = getJson(`${getConfig().stargateRoot}/me`).then(me => {
      var _me$extended_profile;
      return {
        userId: me.account_id,
        locale: me.locale,
        fullName: me.name,
        avatarUrl: me.picture,
        email: me.email,
        title: (_me$extended_profile = me.extended_profile) === null || _me$extended_profile === void 0 ? void 0 : _me$extended_profile.job_title
      };
    });
    return this.promise;
  }
}
export const userInfoProvider = new UserInfoProvider();